<!--suppress TypeScriptValidateTypes -->
<template>
  <div class="break-point-carousel">
    <div class="mdn-Row no-desktop">
      <div class="mdn-Col-lg text-center">
        <h1 class="mdn-Heading mdn-Heading--xs">Nossas ofertas</h1>
        <span class="mark"><b>_____</b></span>
      </div>
    </div>
    <div class="carousel-mobile">
      <CardMobile
        v-for="plan in plans"
        :plan="plan"
        :key="`${plan.id}-card-mobile`"
        :isOpen="plan.id === openPlanMobile"
        @register="goToRegister"
        @showModalDescription="openModalDescription"
        @OpenPlanMobile="openPlanMobile = plan.id"
      />
    </div>
    <div class="carousel-home carousel-desktop">
      <div class="carousel-home-container">
        <swiper
          ref="swiperElement"
          :pagination="{ clickable: true }"
          :watch-slides-progress="true"
          :prevent-clicks="false"
          :prevent-clicks-propagation="false"
          :options="swiperOptions"
          wrapper="div"
        >
          <swiper-slide v-for="plan in plans" :key="plan.id" class="slide">
            <CarouselCardPlan
              :plan="plan"
              :key="`${plan.id}-card`"
              @register="goToRegister"
              @showModalDescription="openModalDescription"
            />
          </swiper-slide>
        </swiper>
      </div>
      <div
        class="mdn-Swiper-pagination-custom carousel-home-buttons-container mt-0 justify-center justify-lg-start"
      >
        <div class="mdn-Swiper-button-prev p-prev">
          <i class="mdn-Icon-esquerda mdn-Icon--lg"></i>
        </div>
        <div class="mdn-Swiper-button-next p-next">
          <i class="mdn-Icon-direita mdn-Icon--lg"></i>
        </div>
      </div>
      <AccessibilitySkipLink :insideContainer="true" />
    </div>
    <PlanDialog
      :show-modal="descriptionModal.show"
      :plan="descriptionModal.plan"
      @isClose="closeModal"
    >
    </PlanDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ActionMethod } from "vuex";
import { Action, Getter } from "vuex-class";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import CardPlan from "@/components/core/CardPlan.vue";

import PlanDialog from "../common/PlanDialog/index.vue";
import AccessibilitySkipLink from "@/components/common/AccessibilitySkipLink.vue";
import CarouselCardPlan from "@/components/Swiper/CarouselCardPlan.vue";
import { LocalPlansType } from "@/types/PlansType";
import { CouponType } from "@/types/CouponTypes";
import "swiper/css/swiper.min.css";
import { homeTagEvents } from "@/helpers/Gtm/gaExecuteEvents";
import CardMobile from "./CardMobile.vue";
import { getHomePlans } from "@/domains/mount-plans.domain";

type modalHomeDescription = {
  show: boolean;
  plan: LocalPlansType;
};

@Component({
  name: "CarouselHome",
  components: {
    CardMobile,
    Swiper,
    SwiperSlide,
    CarouselCardPlan,
    CardPlan,
    PlanDialog,
    AccessibilitySkipLink,
  },
})
export default class CarouselHome extends Vue {
  @Getter coupons!: CouponType[];
  @Getter getIsPortalOff!: boolean;
  @Getter getBonusValue!: string;
  @Getter getShowWebview!: string;
  @Getter getSlidesPerView!: string;
  @Getter getCatalogPlans!: string;
  @Action getAllPlans!: ActionMethod;
  @Action checkCupom!: ActionMethod;
  @Action setPlanSelected!: ActionMethod;
  @Action setWebview!: ActionMethod;
  @Action setCoupon!: ActionMethod;
  openPlanMobile = "";
  descriptionModal: modalHomeDescription = {
    show: false,
    plan: {} as LocalPlansType,
  };
  openModalParam = "";
  plans: LocalPlansType[] = [] as LocalPlansType[];
  monthPlans = new Array<any>();
  monthPlansToShow = new Array<any>();
  plansSkeelo = new Array<any>();
  month = true;
  monthPlansToShowMobile = new Array<any>();
  firstIndex = 0;
  showAlertMessage = false;
  alertMessage = "";
  internet = "";
  price = "";
  discounts = "";
  smsErrorMessage = "false";
  firstAccessRetry = "false";
  cupomSelected = "";
  cupomType = "";
  swiperOptions = {
    breakpoints: {
      360: {
        slidesPerView: 1.1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3.1,
      },
      1200: {
        slidesPerView: 3.1,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: ".p-next",
      prevEl: ".p-prev",
    },
    loop: false,
  };

  closeModal(evt: boolean) {
    homeTagEvents({
      custom_title: `clique-${this.descriptionModal.plan.title}:${
        evt ? "ok-entendi" : "fechar"
      }`,
    });

    this.descriptionModal = {
      show: false,
      plan: {} as LocalPlansType,
    };
  }

  openModalDescription(value: modalHomeDescription): void {
    this.descriptionModal = { ...value };
  }

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  async created() {
    this.plans = await getHomePlans(this.$route.path === "/" ? "HOME" : "B");
    localStorage.removeItem("nome");
    localStorage.removeItem("cpf");
    localStorage.removeItem("email");
    localStorage.removeItem("telefone");
    localStorage.removeItem("isPortability");

    this.$gtm.trackView(this.$route.name!, this.$route.path);

    if (this.getIsPortalOff) {
      this.$router.push({
        name: "Out",
      });
    } else {
      const dataLayerPlans: any = [];

      this.monthPlans.forEach((plan: any, key: number) => {
        dataLayerPlans.push({
          name: this.getLabelName(plan),
          id: plan.id,
          price: plan.totalPrice.amountFormatted,
          brand: "claro-movel",
          category: "plano/celular/flex",
          variant: "migracao",
          list: "planos",
          position: key + 1,
        });
      });

      const win = window as any;
      if (this.$gtm.enabled()) {
        win.dataLayer.push({
          event: "productImpressions",
          eventAction: "product-impression",
          eventCategory: "claro-flex:enhanced-ecommerce",
          noInteraction: "1",
          ecommerce: {
            impressions: dataLayerPlans,
          },
        });
      }

      if (
        process.env.VUE_APP_API_URL !==
        "https://prd-gw-flex.claro.com.br/rw-middleware/v1"
      ) {
        this.move(2, 0);
        this.move(2, 1);
      }
      if (
        process.env.VUE_APP_API_URL ===
        "https://prd-gw-flex.claro.com.br/rw-middleware/v1"
      ) {
        this.move(1, 0);
      }
      this.plansSkeelo = this.monthPlans.slice(3, 6);
      this.firstIndex = 0;
    }
  }

  move(from: number, to: number): void {
    const element = this.monthPlansToShow[from];
    this.monthPlansToShow.splice(from, 1);
    this.monthPlansToShow.splice(to, 0, element);
    this.monthPlansToShowMobile = this.monthPlansToShow;
  }

  getLabelName(plan: any): string {
    return plan.tag;
  }

  customizeCustomTitle({ plan }: any, totalPlan: number) {
    if (plan.id === "dcba42ab-69ce-4f5a-9ad9-77bb17437238")
      return `clique:${totalPlan}gb-free-fire-quero-esse`;

    if (plan.id === "41a68b43-fde4-4795-bca1-a1dd311a34e9")
      return `clique:${totalPlan}gb-tik-tok-quero-esse`;

    return `clique:${totalPlan}gb-quero-esse`;
  }

  goToRegister(values: any): void {
    const totalPlan = values.plan.price;

    homeTagEvents({
      custom_title: this.customizeCustomTitle(values, totalPlan),
    });

    const { plan } = values;
    const cupomSelected = this.coupons.find(
      (coupon: CouponType) => coupon.planId === plan.id
    );
    this.setCoupon(cupomSelected);

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:botao",
        eventLabel: "quero-esse:".concat(plan.tag),
      });
    }
    const dataLayerPlans: any = [];
    dataLayerPlans.push({
      name: plan.tag,
      id: plan.id,
      price: plan.price,
      brand: "claro-movel",
      category: "plano/celular/flex",
      variant: "migracao",
      quantity: "1",
    });

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "addToCart",
        eventAction: "add-to-card",
        eventCategory: "claro-flex:enhanced-ecommerce",
        ecommerce: {
          add: {
            products: dataLayerPlans,
          },
        },
      });
    }
    this.$store.commit("setLocalPlanSelected", plan);
    this.$router.push({
      name: "NewRegisterConfirm",
      params: {
        skeelo: "false",
        selectedPlan: plan,
        firstAccessRetry: this.firstAccessRetry,
        discounts: this.discounts,
        cupomSelected: String(cupomSelected?.code),
        cupomType: this.cupomType,
        openFrame: this.getShowWebview ? "true" : "false",
      },
    });
  }

  closeModalSms(internet: any): void {
    homeTagEvents({
      custom_title: "clique:modal:ok-entendi",
    });
    const win = window as any;

    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:botao",
        eventLabel: "ok-entendi:".concat(internet),
      });
    }

    this.smsErrorMessage = "false";
    this.showAlertMessage = false;
  }

  opened(id: string): void {
    this.openModalParam = id;
  }

  onCupomCheck(param: any): void {
    this.discounts = param.discounts;
    this.cupomSelected = param.cupomSelected;
    this.cupomType = param.cupomType;
    const win = window as any;
    if (win.dtrum) {
      const idAction = win.dtrum.enterAction(
        "TROCA DE CUPOM: ".concat(this.cupomSelected)
      );
      win.dtrum.leaveAction(idAction);
    }
  }
}
</script>

<style lang="scss">
.break-point-carousel {
  .carousel-mobile {
    display: block;
  }

  .carousel-desktop {
    display: none;
  }

  @media (min-width: 780px) {
    .carousel-mobile {
      display: none;
    }

    .carousel-desktop {
      display: block;
    }
  }
}
.carousel-home {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;

  .carousel-home-container {
    width: 100%;
    min-height: 800px;
    max-width: 1080px;
    margin: 0 auto;
  }

  .carousel-home-buttons-container {
    width: 100%;
    display: flex;
    position: relative !important;
    height: 24px;
    padding: 0;
    margin: 0 0 36px 0;
  }
}

.no-desktop {
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
}
</style>
